import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface AddStarPointsInterface {
  date: string;
  id: string;
}

export const useGetCCStatsForEarnings = () => {
  const mutate = useMutation(({ date, id }: AddStarPointsInterface) => {
    return get(`/external-api/get_monthly_earnings_bydate/${id}`);
  });

  return mutate;
};

export default useGetCCStatsForEarnings;
